import { useState } from "react";
import { useAppDispatch } from "../../store/reduxHooks";
import { AsyncThunkAction } from "@reduxjs/toolkit";

// хук отслеживающий состояние отправки запроса, выполняющийся с помощью redux-thunk

export const useThunkActionLoadingState = () => {
  const [isFetching, setIsFetching] = useState(false);
  const dispatch = useAppDispatch();
  const sendQuery = async <T = any>(
    thunkAction: AsyncThunkAction<T, any, any>
  ) => {
    setIsFetching(true);
    try {
      const response = await dispatch(thunkAction).unwrap();
      setIsFetching(false);
      return { data: response };
    } catch (e) {
      setIsFetching(false);
      return { error: e };
    }
  };

  return { sendQuery, isFetching };
};
